import { DEFAULT_LOCALE, LOCALES, type Locale } from "../contract/auth";

const isLocale = (v: string | undefined): v is Locale =>
  v !== undefined && (LOCALES as readonly string[]).includes(v);

/**
 * Interface Language resolution, shared by server and client:
 * the b2a_lang cookie, then Accept-Language / navigator.language, then German.
 */
export function resolveLocale(
  cookieValue: string | undefined,
  acceptLanguage: string | undefined | null,
): Locale {
  if (isLocale(cookieValue)) return cookieValue;
  for (const candidate of parseAcceptLanguage(acceptLanguage ?? "")) {
    const base = candidate.toLowerCase().split("-")[0];
    if (isLocale(base)) return base;
  }
  return DEFAULT_LOCALE;
}

/** Tags ordered by q value, highest first. */
export function parseAcceptLanguage(header: string): string[] {
  return header
    .split(",")
    .map((part, index) => {
      const [tag, ...params] = part.trim().split(";");
      const q = params
        .map((p) => p.trim())
        .find((p) => p.startsWith("q="))
        ?.slice(2);
      const weight = q === undefined ? 1 : Number.parseFloat(q);
      return { tag: (tag ?? "").trim(), weight: Number.isNaN(weight) ? 0 : weight, index };
    })
    .filter((x) => x.tag !== "" && x.tag !== "*" && x.weight > 0)
    .sort((a, b) => b.weight - a.weight || a.index - b.index)
    .map((x) => x.tag);
}
